import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';

export function CopyButton({ textToCopy }: { textToCopy: string }) {
	const [copied, setCopied] = useState(false);

	const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		void navigator.clipboard.writeText(textToCopy);
		setCopied(true);

		setTimeout(() => {
			setCopied(false);
		}, 5000);
	};

	return !copied ?
			<IconButton size='small' onClick={handleClick}>
				<ContentCopyIcon fontSize='inherit' />
			</IconButton>
		:	<CheckIcon fontSize='small' className='text-green-a11' />;
}
